import { ReactElement, useState } from 'react';
import { Typography } from '@mui/material';

import { useTranslation } from 'modules/i18n';
import { LiquidStakingTab } from 'modules/liquidStaking/const';
import { useLiquidStakingPool } from 'modules/liquidStaking/hooks/useLiquidStakingPool';

import { Claim } from '../Claim';
import { Stake } from '../Stake';
import { Unstake } from '../Unstake';
import { translation } from './translation';
import { useStyles } from './useStyles';

interface IContentProps {
  defaultTab?: LiquidStakingTab;
}

export function Tabs({
  defaultTab = LiquidStakingTab.Stake,
}: IContentProps): ReactElement {
  const { t, keys } = useTranslation(translation);
  const { classes, cx } = useStyles();
  const { isDeprecated } = useLiquidStakingPool();

  const [tab, setTab] = useState(
    isDeprecated ? LiquidStakingTab.Unstake : defaultTab,
  );

  return (
    <div className={classes.root}>
      <div className={classes.tabs}>
        {!isDeprecated && (
          <Typography
            className={cx(
              classes.tab,
              tab === LiquidStakingTab.Stake && classes.activeTab,
            )}
            onClick={() => setTab(LiquidStakingTab.Stake)}
          >
            {t(keys.stake)}
          </Typography>
        )}

        <Typography
          className={cx(
            classes.tab,
            tab === LiquidStakingTab.Unstake && classes.activeTab,
          )}
          onClick={() => setTab(LiquidStakingTab.Unstake)}
        >
          {t(keys.unstake)}
        </Typography>

        <Typography
          className={cx(
            classes.tab,
            tab === LiquidStakingTab.Withdrawal && classes.activeTab,
          )}
          onClick={() => setTab(LiquidStakingTab.Withdrawal)}
        >
          {t(keys.claim)}
        </Typography>
      </div>

      {tab === LiquidStakingTab.Stake && !isDeprecated && <Stake />}

      {tab === LiquidStakingTab.Unstake && <Unstake />}

      {tab === LiquidStakingTab.Withdrawal && <Claim />}
    </div>
  );
}
